module.exports = __webpack_public_path__ + "static/title.57cb00b8.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/title.png
// module id = 1051
// module chunks = 2